import { Capacitor } from '@capacitor/core';
import { environment } from '@sprint-expert/environments/environment';
import { OAuthModuleConfig } from 'angular-oauth2-oidc';

export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls:
      Capacitor.getPlatform() === 'ios'
        ? environment.authAllowedUrls.ios
        : Capacitor.getPlatform() === 'android'
          ? environment.authAllowedUrls.android
          : environment.authAllowedUrls.web,
    sendAccessToken: true,
  },
};
